import { CSSObject } from '@chakra-ui/react';
import {
  TAccordionButton,
  TAccordionItem,
  TAccordionPanel,
} from './MarketsByMatch.styles';

export const AccordionItem = ({ isNested }: TAccordionItem): CSSObject => ({
  borderRadius: 'md',
  contain: 'paint',
  boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.25)',
  mb: '3',
  border: '0',

  ...(isNested && {
    boxShadow: 'unset',
    mb: '2',
  }),
});

export const AccordionPanel = ({ isNested }: TAccordionPanel): CSSObject => ({
  border: 0,
  p: '2',
  borderBottomRadius: 'md',
  bg: 'gray.100',

  ...(isNested && {
    border: '1px',
    borderTop: 0,
    borderColor: 'blackAlpha.200',
    bg: 'white',
    boxShadow:
      '0px 3px 8px 0px rgba(0, 0, 0, 0.20), 0px 1px 0px 0px rgba(255, 255, 255, 0.15) inset;',
    py: 0,
  }),
});

export const AccordionButton = ({ isNested }: TAccordionButton): CSSObject => ({
  bg: 'alpha.800',
  h: '32px',
  color: 'white',

  borderRadius: 'md',
  fontWeight: 'semibold',
  fontSize: 'sm',
  p: '2',
  border: '1px',
  borderColor: 'transparent',
  justifyContent: 'space-between',

  svg: {
    border: '1px',
    borderColor: 'white',
    color: 'white',
    borderRadius: '100%',
    boxSize: '20px',
  },

  _hover: {
    bg: 'alpha.800',
  },

  ...(isNested && {
    '&&&': {
      bg: 'alpha.800',
      border: '1px',
      borderColor: 'blackAlpha.200',
      color: 'white',

      svg: {
        borderColor: 'white',
        color: 'white',
      },

      _expanded: {
        color: 'white',
        borderBottomRadius: 0,
        borderBottom: 0,
      },
    },
  }),

  _expanded: {
    borderBottomRadius: 'none',
    bg: 'alpha.800',
    color: 'white',
    borderColor: 'transparent',
    borderBottomColor: '#4B5A6D',

    _hover: {
      bg: 'alpha.900',
    },

    ...(isNested && {
      bg: 'alpha.800',
      color: 'white',
      borderBottomColor: 'transparent',

      _hover: {
        bg: 'alpha.900',
      },
    }),
  },
});

export const BoxWrapper: CSSObject = {
  mx: ['2', null, null, '0'],
  px: ['2', null, null, '4'],
  py: ['2'],
  borderBottomRadius: '6px',
};
